module.exports = __webpack_public_path__ + "img/IMG_1463.d639f0eb.jpg";